export function preventAutoHide(): void {}
export function hide(): void {}
